import './style.css'
import { initApp } from './app.js'

initApp()
